import React, { useState } from "react";
import useWindowDimensions from "../../../../../../../../components/get-diemensions/UseWindowDiemensions";
import { BlackAndWhite } from "../../../../../../../../themes/Colors";
import {
  BaseButtons,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../../../../../components/atoms";
import CategorySelector from "../category-select/CategorySelector";
import { LoadingPopUp } from "../../../../../../../../components";

const AddPromtions = ({
  setClose,
  category,
  setMessage,
  auth,
  setToastPop,
}) => {
  const { width, height } = useWindowDimensions();
  const date = new Date();
  const [categorySelected, setCategorySelected] = useState(null);

  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [loading, setLoading] = useState(false);

  const createNewPromotionHandler = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/promotionRoute/createNewPromotion",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            createdBy: auth.firstName + " " + auth.lastName,
            createdOn: new Date(),
            status: "Active",
            category: categorySelected,
            description: description,
            discountAmount: amount,
            promotionName: name,
            staffUserId: auth.userId,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setClose(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setLoading(false);
      } else {
        setLoading(false);
        setToastPop(true);
        setMessage(respnseData.message);
      }
    } catch (err) {
      setLoading(false);
      setToastPop(true);
      setMessage("no network, please try again later");
      console.log("test", err);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 60,
        width: width,
        height: height - 60,
        backgroundColor: BlackAndWhite.secondary,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        <CloseButton label={"X"} onClick={() => setClose(false)} />
        <div style={{ marginLeft: 20 }}>ADD NEW PROMOTION</div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: 60,
          width: 300,
        }}
      >
        <TextInputField
          labelTitle={"Promotion Name"}
          invert={true}
          mini={true}
          onChange={(e) => setName(e.target.value)}
          value={name}
          size={270}
          placeholder={"i.e 2 gh pre-roll"}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", width: 300 }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          date created
        </div>
        <div
          style={{
            marginTop: 3,
            marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 18,
            // opacity: 0.7,
          }}
        >
          {String(date).substring(0, 16)}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", width: 300 }}>
        <div
          style={{
            marginTop: 10,
            marginLeft: 10,
            fontWeight: "bold",
            fontSize: 12,
            opacity: 0.7,
          }}
        >
          Category
        </div>
        <CategorySelector
          categoriesArray={category}
          selectedCategory={categorySelected}
          setSelectedCategory={setCategorySelected}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            marginTop: 3,
            // marginLeft: 10,
            // fontWeight: "bold",
            fontSize: 16,
            // opacity: 0.7,
            minHeight: 75,
            overflow: "hidden",
            width: 320,
          }}
        >
          <TextAreaInput
            mini={true}
            labelTitle={"DESCRIPTION"}
            invert={true}
            color={BlackAndWhite.primary}
            size={280}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: 300,
          marginTop: 10,
        }}
      >
        <TextInputField
          mini={true}
          labelTitle={"DISCOUNT AMOUNT"}
          invert={true}
          size={275}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type={"number"}
        />
      </div>
      <div
        style={{ position: "absolute", top: 10, right: 10, display: "flex" }}
      >
        <BaseButtons
          marginTopFalse={true}
          label={"SUBMIT"}
          mini={true}
          marginRight={10}
          height={40}
          onClick={() => createNewPromotionHandler()}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              // marginTop: 10,
              // marginLeft: 10,
              fontWeight: "bold",
              fontSize: 12,
              opacity: 0.7,
              width: "100%",
              textAlign: "right",
            }}
          >
            Created by
          </div>
          <div
            style={{
              marginTop: 3,
              // marginLeft: 10,
              fontWeight: "bold",
              fontSize: 14,
              // opacity: 0.7,
              width: "100%",
              textAlign: "right",
            }}
          >
            {auth.firstName + " " + auth.lastName}
          </div>
        </div>
      </div>
      <LoadingPopUp display={loading} newWidth={width} />
    </div>
  );
};

export default AddPromtions;
